var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKababChatBoticon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 4 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 20833",
  transform: "translate(-7937 3299)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 793",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(7937 -3299)"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 794",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(7937 -3289)"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 795",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(7937 -3279)"
}))));
export default __webpack_public_path__ + "static/KababChatBoticon.2b773039fc14d5719c40223dbdb84cb7.svg";
export { SvgKababChatBoticon as ReactComponent };